import { useScrollAnimation } from "@/hooks/useScrollAnimation";
import { Calendar, Film, Users, BookOpen, TrendingUp } from "lucide-react";

const ContentCalendarExample = () => {
  const anim = useScrollAnimation();

  const weeks = [
    {
      week: "Woche 1",
      icon: Film,
      theme: "Behind-the-Scenes",
      description: "Zeigen Sie, wie Ihre Produkte entstehen oder wie Ihr Team arbeitet",
      content: ["2x Reels (Produktion)", "3x Stories (Team)", "1x Karussell-Post"],
      example: "Blick hinter die Kulissen: So entsteht unser Produkt"
    },
    {
      week: "Woche 2",
      icon: TrendingUp,
      theme: "Produkt-Highlights",
      description: "Präsentieren Sie Ihre Produkte oder Dienstleistungen im besten Licht",
      content: ["2x Reels (Produkt)", "3x Stories (Features)", "1x Static Post"],
      example: "Produktfeature der Woche mit Vorher-Nachher"
    },
    {
      week: "Woche 3",
      icon: Users,
      theme: "Customer Testimonials",
      description: "Lassen Sie zufriedene Kunden für sich sprechen",
      content: ["1x Interview-Video", "3x Stories (Reviews)", "1x Karussell (Testimonials)"],
      example: "Kundenstimme: Warum sie uns empfehlen"
    },
    {
      week: "Woche 4",
      icon: BookOpen,
      theme: "Educational Content",
      description: "Teilen Sie Ihr Wissen und positionieren Sie sich als Experte",
      content: ["2x Tutorial-Reels", "3x Stories (Tipps)", "1x Infografik"],
      example: "5 Tipps für... / How-to Video"
    }
  ];

  return (
    <section className="section-padding bg-muted/20">
      <div
        ref={anim.ref}
        className={`container-custom transition-all duration-1000 ${
          anim.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"
        }`}
      >
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-primary/10 px-4 py-2 rounded-full mb-6">
            <Calendar className="w-5 h-5 text-primary" />
            <span className="text-sm font-semibold text-primary">Content-Planung</span>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            So sieht ein Monat Social Media Content aus
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto text-lg">
            Strukturierter Content-Mix für konstantes Wachstum und maximales Engagement
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-6xl mx-auto mb-12">
          {weeks.map((week, index) => (
            <div
              key={index}
              className="bg-background/50 backdrop-blur-xs border border-primary/20 rounded-2xl p-6 hover:border-primary/40 hover:shadow-lg transition-all"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center">
                  <week.icon className="w-6 h-6 text-primary" />
                </div>
                <div>
                  <span className="text-sm font-semibold text-primary">{week.week}</span>
                  <h3 className="text-xl font-bold">{week.theme}</h3>
                </div>
              </div>
              
              <p className="text-muted-foreground mb-4">{week.description}</p>
              
              <div className="bg-muted/30 rounded-lg p-4 mb-4">
                <h4 className="font-semibold text-sm mb-2">Content-Mix:</h4>
                <ul className="space-y-1">
                  {week.content.map((item, idx) => (
                    <li key={idx} className="text-sm text-muted-foreground flex items-center gap-2">
                      <div className="w-1.5 h-1.5 rounded-full bg-primary" />
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
              
              <div className="border-l-4 border-primary/40 pl-4">
                <span className="text-xs uppercase tracking-wide text-muted-foreground">Beispiel</span>
                <p className="text-sm font-medium mt-1">{week.example}</p>
              </div>
            </div>
          ))}
        </div>


        <div className="mt-12 text-center max-w-3xl mx-auto">
          <p className="text-muted-foreground">
            <strong>Individuelle Anpassung:</strong> Jeder Content-Plan wird auf Ihre Branche, Zielgruppe und Unternehmensziele abgestimmt. Von Hotels in Mannheim bis Tech-Unternehmen in Frankfurt.
          </p>
        </div>
      </div>
    </section>
  );
};

export default ContentCalendarExample;
